<template>
  <div class="wraper">
    <div class="title">
      <img src="@/assets/img/YanShiHuiBao/Title2.png" alt="" />
    </div>
    <div class="name_wraper">
      <div class="top">
        <img
          @click="back"
          src="@/assets/img/YanShiHuiBao/title_back.png"
          alt=""
        />
        <p>演示名称</p>
        <input type="text" v-model="editInfo.name" />
      </div>
      <div class="btns">
        <div class="btn" @click="addView">
          <img src="@/assets/img/YanShiHuiBao/add.png" alt="" />
          添加视点
        </div>
        <div class="btn" @click="showLine">
          <img src="@/assets/img/YanShiHuiBao/view.png" alt="" />
          预览全部
        </div>
      </div>
    </div>
    <div class="view_list">
      <div class="empty" v-show="editInfo.views.length == 0">
        当前无视点任务
      </div>
      <ViewItem
        v-for="(item, index) in editInfo.views"
        :key="item.name + index"
        :itemInfo="item"
        :index="index"
        @moveItemUp="moveItemUp"
        @moveItemDown="moveItemDown"
        @setShow="setShow"
        @copyItem="copyItem"
        @deleteItem="deleteItem"
      ></ViewItem>
    </div>
  </div>
</template>

<script>
import ViewItem from './ViewItem.vue'
export default {
  components: {
    ViewItem,
  },
  props: {
    editInfo: {
      type: Object,
      default: () => {
        return {
          name: '',
          views: [],
        }
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    // 返回
    back() {
      this.$emit('back')
    },
    // 添加视角
    addView() {
      let viewObj = {
        name: '新建视点',
        delay: 2,
        flyTime: 2,
        explain: '',
        isShow: true,
        cameraInfo: {},
        img: '',
      }
      this.$store.commit('setLoading', true)
      let todo = 0
      appInstance.uniCall('takeSnapshot', {}, (res) => {
        this.comCompress(res.snapshot).then((res) => {
          viewObj.img = res
        })
        // viewObj.img = res.snapshot
        todo++
        if (todo == 2) {
          this.$store.commit('setLoading', false)
          this.editInfo.views.push(viewObj)
        }
      })
      appInstance.uniCall('getCameraInfo', {}, (res) => {
        let cameraInfo = {
          centerCoord: res.centerCoord,
          coordType: res.coordType,
          coordTypeZ: res.coordTypeZ,
          coordZ: res.coordZ,
          distance: res.distance,
          heading: res.heading,
          pitch: res.pitch,
        }
        viewObj.cameraInfo = cameraInfo
        todo++
        if (todo == 2) {
          this.$store.commit('setLoading', false)
          this.editInfo.views.push(viewObj)
        }
      })
    },
    // 压缩截图大小
    comCompress(base64String) {
      var newImage = new Image()
      var imgWidth, imgHeight
      var promise = new Promise((resolve) => (newImage.onload = resolve))
      newImage.src = base64String
      return promise.then(() => {
        imgWidth = newImage.width
        imgHeight = newImage.height
        var canvas = document.createElement('canvas')
        var ctx = canvas.getContext('2d')
        canvas.width = imgWidth * 0.2
        canvas.height = imgHeight * 0.2
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height)
        var base64 = canvas.toDataURL('image/jpeg', 0.9)
        return base64
      })
    },
    swapArray(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      return arr
    },
    moveItemUp(index) {
      if (index == 0 || this.editInfo.views.length == 1) {
        return
      }
      this.editInfo.views = this.swapArray(
        this.editInfo.views,
        index - 1,
        index
      )
    },
    moveItemDown(index) {
      if (index == this.editInfo.views.length - 1) {
        return
      }
      this.editInfo.views = this.swapArray(
        this.editInfo.views,
        index,
        index + 1
      )
    },
    setShow(index, flag) {
      this.editInfo.views[index].isShow = flag
    },
    copyItem(index) {
      let info = this.editInfo.views[index]
      let obj = {
        name: info.name + '_复制',
        delay: info.delay,
        flyTime: info.flyTime,
        explain: info.explain,
        isShow: info.isShow,
        cameraInfo: info.cameraInfo,
        img: info.img,
      }
      this.editInfo.views.splice(index + 1, 0, obj)
    },
    deleteItem(index) {
      this.editInfo.views.splice(index, 1)
    },
    // 预览所有视角
    showLine() {},
  },

  mounted() {},
}
</script>

<style lang="less" scoped>
.wraper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.title {
  background-color: rgba(18, 32, 46, 0.75);
  height: 75px;
  border: 1px #797f86 solid;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding-left: 30px;
  flex: 0 0 auto;
  box-sizing: border-box;
}
.name_wraper {
  background-color: rgba(18, 32, 46, 0.75);
  height: 140px;
  border: 1px #797f86 solid;
  box-sizing: border-box;
  .top {
    height: 75px;
    display: flex;
    padding: 0 25px;
    align-items: center;
    img {
      width: 30px;
    }
    p {
      font-size: 26px;
      color: #fff;
      margin: 0 20px;
    }
    input {
      width: 450px;
      background-color: #272729;
      border: 2px #4d505e solid;
      color: #fff;
      font-size: 26px;
      height: 50px;
      text-indent: 20px;
    }
  }
  .btns {
    display: flex;
    justify-content: space-around;
    width: 90%;
    margin: 0 auto;
    align-items: center;
    .btn {
      width: 280px;
      height: 50px;
      border-radius: 4px;
      background-color: #189bfa;
      font-weight: bold;
      color: #fff;
      line-height: 50px;
      font-size: 28px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-right: 4px;
      }
    }
  }
}
.view_list {
  width: 100%;
  height: 1450px;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px #797f86 solid;
  box-sizing: border-box;
  background-color: rgba(18, 32, 46, 0.75);
  .empty {
    text-align: center;
    color: #fff;
    font-size: 28px;
    line-height: 40px;
  }
}
</style>
